import { Badge, Box, Group, Stack, Text } from '@mantine/core';

const VariationsCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return <Text>{rowData.variations}</Text>;
};

const VariationsColumn = () => ({
    accessorKey: 'variations',
    header: 'Variations',
    size: 2,
    minSize: 80,
    Cell: ({ cell }) => <VariationsCell cell={cell} />,
});
export default VariationsColumn;
